module.exports = require("react-select");


//////////////////
// WEBPACK FOOTER
// external "react-select"
// module id = 9
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///external "react-select"